import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AgentRating } from '../classes/agentRating';
import { CacheService } from './cache.service';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ApiConfigService } from './api-config/api-config.service';
import { IAppConfig } from '../app-config.interface';
import { APP_CONFIG } from '../app-config.constants';

@Injectable({
  providedIn: 'root'
})
export class RankMyAgentService {

  constructor(
    private httpClient: HttpClient,
    private cache: CacheService,
    @Inject(APP_CONFIG) private appConfig: IAppConfig,
    private apiConfigService: ApiConfigService
  ) { }

  getAgentRating(personifyId: string): Observable<AgentRating> {
    const apiRoot = this.apiConfigService.getServerRoot(this.appConfig.urls.agent.base);
    const route = `${this.appConfig.urls.agent.base}${personifyId}/ratings`;
    const hashKey = this.cache.getRequestHash(route, null);
    const hashValue = this.cache.get<AgentRating>(hashKey);
    if (hashValue) {
      return of(!!hashValue['result'].personify_id ? hashValue : null); // Check if cached value has any data, otherwise return null instead of {}
    }

    return this.httpClient.get<AgentRating>(apiRoot + route, { withCredentials: false }).pipe(
      catchError((err: HttpErrorResponse) => of(null)),   // Run catchError before caching so we can cache a 404
      tap(rating => this.cache.set(hashKey, rating, 1000))
    );
  }
}
